export function generatePlanPayload(properties) {
    const sharesWithAllTeachers = properties.plan.is_visible_for_teachers || properties.plan.is_editable_for_teachers;
    const payload = {
        [properties.entityFieldName]: properties.entityId,
        documentable_type: properties.documentableType,
        title: properties.plan.title || '',
        blocks: properties.blocks,
        start_at: properties.plan.start_at,
        description: properties.plan.description || '',
        is_draft: !properties.isPublish,
        end_at: properties.plan.end_at || '',
        is_visible_for_guardians: properties.plan.is_visible_for_guardians || false,
        is_visible_for_teachers: properties.plan.is_visible_for_teachers || false,
        is_editable_for_teachers: properties.plan.is_editable_for_teachers || false,
        teachers: sharesWithAllTeachers
            ? []
            : (properties.selectedTeachers || []).map((teacher) => ({
                id: teacher.value,
                permission: teacher.permission,
            })),
        status_id: properties.plan.status?.id || '',
        publish: properties.isPublish,
    };
    if (properties.id) {
        payload.uuid = properties.id;
    }
    return payload;
}
